import { render, staticRenderFns } from "./ColumnMapper.vue?vue&type=template&id=9aba4eb8&scoped=true&"
import script from "./ColumnMapper.vue?vue&type=script&lang=js&"
export * from "./ColumnMapper.vue?vue&type=script&lang=js&"
import style0 from "./ColumnMapper.vue?vue&type=style&index=0&id=9aba4eb8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9aba4eb8",
  null
  
)

export default component.exports